/* eslint-disable */
// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { state } from "../../../../api/Api";

export const getAllState = createAsyncThunk(
  "appState/getAllState",
  async (query) => {
    try {
      return state.getAll(query);
    } catch (error) {
      console.error(error);
    }
  }
);

export const getState = createAsyncThunk("appState/getState", async (id) => {
  try {
    return state.getState(id);
  } catch (error) {
    console.error(error);
  }
});

export const addState = createAsyncThunk(
  "appState/addState",
  async ({ user, func }) => {
    try {
      return state.create(user, func);
    } catch (error) {
      console.error(error);
    }
  }
);

export const deleteState = createAsyncThunk(
  "appState/deleteState",
  async (id) => {
    return state.delete(id);
  }
);

export const addTax = createAsyncThunk("appTax/addTax", async (values) => {
  try {
    return state.createTax(values);
  } catch (error) {
    console.error(error);
  }
});

export const editTax = createAsyncThunk("appTax/editTax", async (values) => {
  return state.editTax(values);
});

export const appStateSlice = createSlice({
  name: "appState",
  initialState: {
    state: [],
    stateFeached: false,
    metaData: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllState.fulfilled, (state, action) => {
      state.metaData = action.payload.data.metaData;
      state.state = action.payload?.data?.data;
      state.stateFeached = true;
    });
  },
});

export default appStateSlice.reducer;
